@if(loadingiframeUrl)
{
<div>
  <div class="snappayloading">
    <!-- Processing Graphic -->
    <div class="lds-css ng-scope">
      <div class="lds-spin">
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    </div>
    <span class="sr-only">Loading</span>
    <!-- End Processing Graphic -->
  </div>
</div>
}
<div name="form" [ngClass]="{'d-none' : loadingiframeUrl}">
  <div class="cccardlabelwrapper paymentpage-block">
    <label for="ccnumfield" class="cccardlabel" id="cccardlabel">Card Number</label>
    <div class="iframe-snappay">
      @if(iframeURL)
      {
      <iframe [src]="iframeURL" class="iframe" title="Credit Card Collection"></iframe>
      }
    </div>
  </div>
  <div class="expiration-cvv">
  <div class="iframe-snappay-expdate paymentpage-block">
    <label for="expirymonth" id="ccexpirylabel">Expiration Date</label>
    <span class="expiration">
      <span class="textbox-expmonth">
        <kendo-numerictextbox [spinners]="false"
                              [(ngModel)]="expirymonth"
                              [required]="true"
                              [format]="'##'"
                              name="txtBoxNameExpMonth"
                              id="txtBoxIdExpMonth"
                              class="input-number"
                              [min]="1"
                              [max]="12"
                              [autoCorrect]="false">
        </kendo-numerictextbox>
      </span>/
      <span class="textbox-expyear">
        <kendo-numerictextbox [spinners]="false"
                              [(ngModel)]="expiryyear"
                              [required]="true"
                              [format]="'##'"
                              name="txtBoxNameExpYear"
                              id="txtBoxIdExpYear"
                              class="input-number textbox-expyear"
                              [min]="21"
                              [max]="99"
                              [maxlength]="2"
                              [style.width.px]="50"
                              [autoCorrect]="false">
        </kendo-numerictextbox>
      </span>
    </span>
  </div>
  <div class="iframe-snappay-cvv paymentpage-block">
    <label for="cccvvfield" id="cccvvlabel">CVV</label>
    <kendo-numerictextbox [spinners]="false"
                          [(ngModel)]="cvv"
                          [required]="true"
                          [format]="'###'"
                          name="txtBoxNamecvv"
                          id="txtBoxIdcvv"
                          class="input-number textbox-cvv"
                          [autoCorrect]="false">
    </kendo-numerictextbox>
  </div>
  </div>
</div>

